module.exports = __webpack_public_path__ + "static/media/fa-regular-400.e5770f98.woff";